import { fork } from 'redux-saga/effects'

import kioskModeSaga from './kioskMode';
import volunteersSaga from './volunteers'
import waiversSaga from './waivers';
import timesheetSaga from './timesheet';
import notificationsSaga from './notifications';

export default function* rootSaga() {
    yield fork(kioskModeSaga);
    yield fork(volunteersSaga);
    yield fork(waiversSaga)
    yield fork(timesheetSaga);
    yield fork(notificationsSaga);
}